import { tns } from 'tiny-slider/src/tiny-slider';

(function () {

  if (!document.body.classList.contains('home')) return this;

  const slider = tns({
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 6000,
    container: '.home-gallery',
    controls: false,
    items: 1,
    loop: true,
    nav: true,
    navPosition: 'bottom',
    navContainer: "#customize-nav",
    mode: 'gallery',
    slideBy: 'page',
    speed: 2000,
  });

  const nav_buttons = document.querySelectorAll('#customize-nav button');
  const startAutoplay = () => {
    slider.play();
  }

  nav_buttons.forEach((item, i) => {
    item.addEventListener("mouseleave", startAutoplay);
    item.addEventListener("touchend", (e) => {
      setTimeout(startAutoplay, 100);
    });
  });


})();
